<template>
  <div>
    <v-container fluid>
      <v-card>
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>Faturamento</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="tooglePesquisa">
            <v-icon>search</v-icon>
          </v-btn>
        </v-app-bar>

        <v-expand-transition>
          <v-row dense v-show="exibirPesquisa" class="pa-2">
            <v-col cols="12" pa-2>
              <v-text-field
                ref="pesquisa"
                label="Pesquisa"
                v-model="pesquisa"
                prepend-inner-icon="search"
                solo
                clearable
                single-line
                hide-details
                placeholder="Pesquisa"
                dark
                background-color="primary lighten-2"
                @click:clear="tooglePesquisa"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-expand-transition>

        <v-data-table
          :search="pesquisa"
          :headers="headers"
          :items="pedidos"
          :loading="loading"
          no-data-text="Sem registros"
          no-results-text="Sem registros"
          loading-text="Carregando dados..."
          :items-per-page="30"
          :footer-props="{ itemsPerPageOptions: [10, 30, 50, { text: 'Todos', value: -1 }], itemsPerPageText: '' }"
        >
          <template v-slot:item.valor_liquido="{item}">
            <td>{{ item.valor_liquido | valorBR }}</td>
          </template>
          <template v-slot:item.acoes="{item}">
            <td>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn slot="activator" icon @click="gerarPromissorias(item)" v-bind="attrs" v-on="on">
                    <v-icon>date_range</v-icon>
                  </v-btn>
                </template>
                <span>Gerar Promissórias</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import ServiceFaturamento from "@/services/faturamento.js";

export default {
  name: "faturamento",
  data() {
    return {
      loading: false,
      exibirPesquisa: false,
      pesquisa: "",
      pedido: {
        parcelas: null,
        prazo: null,
        promissorias: [],
      },
      pedidos: [],
      headers: [
        { text: "Número", value: "id", width: "10%" },
        { text: "Cliente", value: "cliente_nome", width: "40%" },
        { text: "Fornecedor", value: "fornecedor_nome", width: "40%" },
        { text: "Valor", value: "valor_liquido", width: "10%" },
        { text: "Ações", value: "acoes", sortable: false },
      ],
    };
  },
  mounted() {
    this.listar();
  },
  methods: {
    tooglePesquisa() {
      this.exibirPesquisa = !this.exibirPesquisa;
      if (this.exibirPesquisa) {
        setTimeout(() => {
          this.$refs.pesquisa.focus();
        }, 0);
      }
    },
    async listar() {
      try {
        this.loading = true;
        let response = await ServiceFaturamento.listarPedidos();
        this.pedidos = response.data.pedidos;
      } catch (error) {
        console.log(error);
        this.$eventbus.erro('Erro ao listar pedidos');
      } finally {
        this.loading = false;
      }
    },
    gerarPromissorias(pedido) {
      this.$router.push({
        name: "gerar-promissorias",
        params: { id: pedido.id },
      });
    },
  },
};
</script>